/**
 * DO NOT EDIT!
 * This file was autogenerated by Eddie.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx eddie update workspace` to regenerate.
 */

export const PACKAGE_NAME = '@ori/i18n';
export const TEAM_NAME = 'Frontend Platform';
//# sourceMappingURL=constants-generated.js.map